export interface ReviewWarningCardProps {
  className?: string;
}

// TODO: need to finish this component
export const ReviewWarningCard: React.FC<ReviewWarningCardProps> = () => null;
